// src/Pages/ViewCommitmentMaster.jsx
import { useEffect, useState } from "react";
import { Container, Table, Spinner, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { useAuth } from "../Context/AuthContext";
import Sample14 from "../Components/Logo";
import { getAllCommitments } from "../Api/IncomingPo";
import { useNavigate } from "react-router-dom";
import { Base_URL } from "../url";
const toNum = (x) => (x === null || x === undefined || x === "" ? null : Number(x));

const normalizeCommitment = (r) => ({
  id: r?.id ?? r?.Id ?? null,
  description: r?.description ?? r?.Description ?? "",
  amount: toNum(r?.amount ?? r?.Amount) ?? 0,
  userId: toNum(r?.createdBy ?? r?.UserId) ?? null,
  frequency: (r?.frequency ?? r?.Frequency ?? "").toLowerCase(),
  vendor: r?.vendor ?? r?.Vendor ?? "",
  paymentsBank: r?.paymentsBank ?? r?.PaymentsBank ?? "",
  orgId: toNum(r?.orgId ?? r?.OrgId) ?? null,
  companyCode: toNum(r?.companyCode ?? r?.CompanyCode) ?? null,
  type: r?.type ?? r?.Type ?? r?.typeOfCommitment ?? r?.TypeOfCommitment ?? "",
});

const ViewCommitmentMaster = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const orgId = user?.organisationId ?? user?.orgId ?? user?.OrgId ?? null;

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  const loadData = async () => {
    setLoading(true);
    try {
      const raw = await getAllCommitments();
      const normalized = (raw || []).map(normalizeCommitment);
      const scoped = orgId ? normalized.filter((x) => x.orgId === Number(orgId)) : normalized;
      setRows(scoped);
      if (scoped.length === 0) toast.info("No commitments found.");
    } catch (e) {
      console.error(e);
      const msg = e?.response?.data?.message ?? e?.message ?? "Failed to load commitments";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgId]);

  // 👉 Simple direct download
  const handleDownloadExcel = () => {
    // Directly navigate to the API endpoint
    window.location.href = `${Base_URL}/CommitmentMaster/export`;
  };

  const cellStyle = { padding: "0.9rem 0.75rem", verticalAlign: "middle" };

  return (
    <div className="main-content expand">
      <Container fluid className="fields-container">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <h2 className="fields-title m-0">Commitment Master</h2>

          <div className="d-flex gap-2">
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={loadData}
              disabled={loading}
            >
              {loading ? "Refreshing…" : "Refresh"}
            </Button>

            {/* NEW Download button */}
            <Button
              size="sm"
              variant="success"
              onClick={handleDownloadExcel}
            >
              Download Excel
            </Button>
          </div>
        </div>

        <div className="table-responsive">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th style={{ minWidth: 220, ...cellStyle }}>Description</th>
                <th style={{ minWidth: 120, textAlign: "right", ...cellStyle }}>Amount (₹)</th>
                <th style={{ minWidth: 100, ...cellStyle }}>Frequency</th>
                <th style={{ minWidth: 160, ...cellStyle }}>Type of Commitment</th>
                <th style={{ minWidth: 160, ...cellStyle }}>Vendor</th>
                <th style={{ minWidth: 180, ...cellStyle }}>Payments Bank</th>
                <th style={{ minWidth: 100, textAlign: "right", ...cellStyle }}>Company</th>
                <th style={{ minWidth: 100, textAlign: "right", ...cellStyle }}>Org</th>
                <th style={{ minWidth: 100, textAlign: "right", ...cellStyle }}>User</th>
                <th style={{ minWidth: 100, textAlign: "right", ...cellStyle }}>Actions</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={10} className="text-center">
                    <Spinner animation="border" size="sm" className="me-2" />
                    Loading commitments…
                  </td>
                </tr>
              ) : rows.length === 0 ? (
                <tr>
                  <td colSpan={10} className="text-center text-muted">
                    No data
                  </td>
                </tr>
              ) : (
                rows.map((r, idx) => (
                  <tr key={`${r.description}-${idx}`}>
                    <td style={cellStyle}>{r.description}</td>
                    <td style={{ textAlign: "right", ...cellStyle }}>{Number(r.amount).toLocaleString()}</td>
                    <td className="text-capitalize" style={cellStyle}>{r.frequency}</td>
                    <td className="text-capitalize" style={cellStyle}>{r.type}</td>
                    <td style={cellStyle}>{r.vendor}</td>
                    <td style={cellStyle}>{r.paymentsBank}</td>
                    <td style={{ textAlign: "right", ...cellStyle }}>{r.companyCode ?? "-"}</td>
                    <td style={{ textAlign: "right", ...cellStyle }}>{r.orgId ?? "-"}</td>
                    <td style={{ textAlign: "right", ...cellStyle }}>{r.userId ?? "-"}</td>
                    <td>
                      <Button
                        size="sm"
                        variant="outline-primary"
                        onClick={() => navigate(`/commitment/${r.id}/edit`)}
                        disabled={!r.id}
                      >
                        Edit
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </Container>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </div>
  );
};

export default ViewCommitmentMaster;
